exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-lg[data-v-1131fbde]{width:100%;height:209.25px;overflow:hidden}", ""]);

// exports
